export type StudentClassBlock = {
  occurrence_id: number;
  class_id: number;
  start_time: string | null;
  end_time: string | null;
  staff_id: number | null;
  staff_name: string | null;
  subject: string | null;
  mode: string | null;
  location: string | null;
  location_id: number | null;
};

export type StudentDay = {
  date: string;
  weekday: string;
  day: string;
  classes: StudentClassBlock[];
};

export type StudentBlock = {
  student_id: number;
  student_name: string;
  reference_id: string | null;
  grade: string | null;
  week_start: string;
  week_end: string;
  summary: {
    classes: number;
    hours: number;
    staff: number;
    subjects: string[];
    online: number;
    in_person: number;
    locations: string[];
    conflicts: number;
  };
  days: StudentDay[];
};

export type StudentIndexItem = {
  student_id: number;
  student_name: string;
  reference_id: string | null;
  grade: string | null;
  class_count: number;
};

export type Options = {
  grades: { id: number; label: string }[];
  subjects: { id: number; label: string }[];
  staff: { id: number; label: string }[];
  students: { id: number; label: string; reference_id: string | null }[];
  locations: { id: number; label: string }[];
  study_modes: { value: string; label: string }[];
  assignment_statuses: string[];
};

export type FilterState = {
  week_start: string;
  date_from: string;
  date_to: string;
  student_ids: number[];
  location_ids: number[];
  grade_ids: number[];
  staff_ids: number[];
  subject_ids: number[];
  study_modes: string[];
  assignment_statuses: string[];
  include_one_off: boolean;
  student_search: string;
};

function mondayOf(d: Date): string {
  const day = d.getDay();
  const diff = (day === 0 ? -6 : 1 - day);
  const mon = new Date(d);
  mon.setDate(d.getDate() + diff);
  const y = mon.getFullYear();
  const m = String(mon.getMonth() + 1).padStart(2, "0");
  const dd = String(mon.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export const defaultFilter = (): FilterState => ({
  week_start: mondayOf(new Date()),
  date_from: "",
  date_to: "",
  student_ids: [],
  location_ids: [],
  grade_ids: [],
  staff_ids: [],
  subject_ids: [],
  study_modes: [],
  assignment_statuses: [],
  include_one_off: false,
  student_search: "",
});
